import { newrelicAgentSnippet } from "./newrelic-browser-agent"

export const NewRelicSnippet = () => {
    return (
        <script
            type="text/javascript"
            dangerouslySetInnerHTML={{ __html: newrelicAgentSnippet }}
        />
    );
};